import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import classNames from 'classnames'
import axios from 'axios'
import moment from 'moment'
import { queryClient } from '../../config'

const INIT_PROJECT_TYPE_OPTIONS = [
  {
    value: '',
    label: '',
  }]
let Filevine = ({ className }) => {
  const [key, setKey] = useState('')
  const [projectType, setProjectType] = useState('')
  const [projectTypeOptions, setProjectTypeOptions] = useState(INIT_PROJECT_TYPE_OPTIONS)
  const [lastUpdateProjectType, setLastUpdateProjectType] = useState(null)
  const [TypeBaseURL, setTypeBaseURL] = useState('usa')
  const [customBaseURL, setCustomBaseURL] = useState('')
  const [lastUpdate, setLastUpdate] = useState(null)
  const [secret, setSecret] = useState('')


  const fetchFilevine = async () => {
    const { data } = await axios.get('/api/filevine')
    setSecret(data.secret)
    setKey(data.key)
    if (data.baseURL) {
      if (data.baseURL === 'https://api.filevine.io') {
        setTypeBaseURL('usa')
      } else if (data.baseURL === 'https://api.filevine.ca') {
        setTypeBaseURL('canada')
      } else {
        setTypeBaseURL('personalized')
        setCustomBaseURL(data.baseURL.replace('.api.filevineapp.com', '.filevineapp.com'))
      }
    }
    if (data.lastUpdate) {
      setLastUpdate(data.lastUpdate)
      fetchProjectTypes()
    }
    if (data.projectType) {
      setProjectType(data.projectType)
    }
    if (data.lastUpdateProjectType) {
      setLastUpdateProjectType(data.lastUpdateProjectType)
    }
  }

  const fetchProjectTypes = async () => {
    const { data } = await axios.get('/api/filevine/projectTypes')
    setProjectTypeOptions([...INIT_PROJECT_TYPE_OPTIONS, ...data])
  }

  useEffect(() => {
    fetchFilevine()
  }, [])

  const submit = (action = 'activate') => async () => {
    if (key && secret) {
      let baseURL
      if (TypeBaseURL === 'usa') {
        baseURL = 'https://api.filevine.io'
      } else if (TypeBaseURL === 'canada') {
        baseURL = 'https://api.filevine.ca'
      } else if (TypeBaseURL === 'personalized') {
        baseURL = customBaseURL.replace('.filevineapp.com', '.api.filevineapp.com')
      }

      const { data } = await axios.post('/api/filevine/' + action, {
        key,
        baseURL,
        secret,
      })
      if (data.lastUpdate) {
        setLastUpdate(data.lastUpdate)
        fetchProjectTypes()
      }
    }
  }

  const importProjectType = async () => {
    const { data } = await axios.post('/api/filevine/importProject', {
      projectType,
    })
    if (data.lastUpdateProjectType) {
      setLastUpdateProjectType(data.lastUpdateProjectType)
      const URL = '/api/types?fields=name,type,_id'
      const { data: types } = await axios.get(URL)
      await queryClient.clear()
      await queryClient.setQueryData(URL, types)
    }
  }

  return (
    <div className={'container-fluid py-2'}>
      <label className={'mb-2 text-uppercase'}>{'Filevine configuration'}</label>
      <div className={classNames('w-100 border border-dark p-4', className)}>
        <div className={'row'}>
          <div className={'col-3'}>
            <div className="form-group">
              <label htmlFor="displayName">{'Base URL'}</label>
              <select className="form-control rounded-0" id="applicationRegion"
                      value={TypeBaseURL}
                      onChange={event => {
                        setTypeBaseURL(event.target.value)
                      }}>
                <option value={'usa'}>{'United States'}</option>
                <option value={'canada'}>{'Canada'}</option>
                <option value={'personalized'}>{'Personalized'}</option>
              </select>
            </div>
            {(TypeBaseURL === 'personalized') && (
              <div className="form-group">
                <label htmlFor="displayName">{'Personalized base URL'}</label>
                <input type="text" className="form-control rounded-0" id="applicationKey" value={customBaseURL}
                       onChange={event => setCustomBaseURL(event.target.value)}
                       placeholder={'https://{company-name}.filevineapp.com'}/>
              </div>)}
            <div className="form-group">
              <label htmlFor="displayName">{'API Key'}</label>
              <input type="text" className="form-control rounded-0" id="applicationKey" value={key}
                     onChange={event => setKey(event.target.value)}/>
            </div>
            <div className="form-group">
              <label htmlFor="displayName">{'Key Secret'}</label>
              <input type="text" className="form-control rounded-0" id="applicationSecret" value={secret}
                     onChange={event => setSecret(event.target.value)}/>
            </div>
            <div className={'row'}>
              <div className="col-12">
                {lastUpdate ? (
                  <p>Last updated connections on {moment(lastUpdate).format('MM/DD/YYYY')} at {moment(lastUpdate)
                    .format('hh:mm A')}</p>) : (
                  <p>Filevine has not yet been connected.</p>)}

              </div>
              <div className="col-12">
                {lastUpdate ? (
                  <button className="btn btn-secondary dart-btn text-uppercase w-75" onClick={submit('refresh')}>
                    Connection
                  </button>) : (
                  <button className="btn btn-secondary dart-btn text-uppercase w-75" onClick={submit('activate')}>
                    Connection
                  </button>)}

                <div className="form-group mt-2">
                  <label htmlFor="displayName">{'Project Type'}</label>
                  <select className="form-control rounded-0" id="applicationRegion"
                          value={projectType}
                          disabled={!lastUpdate}
                          onChange={event => {
                            setProjectType(event.target.value)
                          }}>
                    {projectTypeOptions.map(Option => (<option value={Option.value}>{Option.label}</option>))}
                  </select>
                </div>
                {lastUpdateProjectType ? (
                  <p>Models last refreshed on {moment(lastUpdateProjectType).format('MM/DD/YYYY')} at {moment(
                    lastUpdateProjectType)
                    .format('hh:mm A')}</p>) : (
                  <p>Models have not yet been imported.</p>)}

                <button className="btn btn-secondary dart-btn text-uppercase w-75" disabled={!lastUpdate}
                        onClick={importProjectType}>
                  Import Project Type
                </button>
              </div>


            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Filevine = styled(Filevine)`
  background-color: ${props => props.theme.colorTable.plain} !important;
  border-color: ${props => props.theme.colorTable.border} !important;
  color: ${props => props.theme.colorTable.textLight} !important;
`
export default Filevine
